export const GET_LIST_POST = 'GET_LIST_POST';
export const GET_LIST_POST_SUCCESS = 'GET_LIST_POST_SUCCESS';
export const GET_LIST_POST_FAIL = 'GET_LIST_POST_FAIL';

export const GET_LIST_ROYALTIES = 'GET_LIST_ROYALTIES';
export const GET_LIST_ROYALTIES_SUCCESS = 'GET_LIST_ROYALTIES_SUCCESS';
export const GET_LIST_ROYALTIES_FAIL = 'GET_LIST_ROYALTIES_FAIL';

export const GET_LIST_ROYALTIES_MONEY = 'GET_LIST_ROYALTIES_MONEY';
export const GET_LIST_ROYALTIES_MONEY_SUCCESS = 'GET_LIST_ROYALTIES_MONEY_SUCCESS';
export const GET_LIST_ROYALTIES_MONEY_FAIL = 'GET_LIST_ROYALTIES_MONEY_FAIL';

export const COUNT_LIST_POST = 'COUNT_LIST_POST';
export const COUNT_LIST_POST_SUCCESS = 'COUNT_LIST_POST_SUCCESS';
export const COUNT_LIST_POST_FAIL = 'COUNT_LIST_POST_FAIL';

export const GET_POST = 'GET_POST';
export const GET_POST_SUCCESS = 'GET_POST_SUCCESS';
export const GET_POST_FAIL = 'GET_POST_FAIL';

export const ADD_NEW_POST = 'ADD_NEW_POST';
export const ADD_NEW_POST_SUCCESS = 'ADD_NEW_POST_SUCCESS';
export const ADD_NEW_POST_FAIL = 'ADD_NEW_POST_FAIL';

export const UPDATE_POST = 'UPDATE_POST';
export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS';
export const UPDATE_POST_FAIL = 'UPDATE_POST_FAIL';

export const DELETE_POST = 'DELETE_POST';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const DELETE_POST_FAIL = 'DELETE_POST_FAIL';

export const SET_CURRENT_POST = 'SET_CURRENT_POST';
export const SET_SELECTED_VALUE = 'SET_SELECTED_VALUE';
export const SET_CURRENT_POST_SUCCESS = 'SET_CURRENT_POST_SUCCESS';
export const SET_CURRENT_POST_FAIL = 'SET_CURRENT_POST_FAIL';

export const CHANGE_TAB_POST = 'CHANGE_TAB_POST';
export const UPDATE_POST_FOROM_SOCKET = 'UPDATE_POST_FOROM_SOCKET';
export const UPDATE_LIST_POST = 'UPDATE_LIST_POST';